import React from 'react';
export function Footer() {
  return <footer className="bg-[#020617] py-8 md:py-12 px-4 sm:px-6 lg:px-8 border-t border-navy-900 text-center" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <div className="text-2xl font-bold text-white mb-4" data-id="element-107">
          👨‍👩‍👧‍👦 PACK 100 CITAS
        </div>

        <p className="text-slate-400 mb-8 max-w-2xl mx-auto" data-id="element-108">
          Menos pantallas, más abrazos. El pack que te ayuda a crear recuerdos
          inolvidables con tu familia.
        </p>

        <div className="text-xs text-slate-500 space-y-2 mb-12" data-id="element-109">
          <p data-id="element-110">© Pack 100 Citas 2026 — Todos los derechos reservados.</p>
          <p data-id="element-111">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <p className="text-sm font-medium text-purple-400/80 italic" data-id="element-112">
          ❤️ «Dentro de unos años… no van a recordar la pantalla. Van a recordar
          lo que vivieron con vos.»
        </p>
      </div>
    </footer>;
}